module.exports = __webpack_public_path__ + "img/EP18Menu3.f38e1c43.png";